import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../shared/api/client'
import type { ManagerDashboardDto, ManagerPeriodKey } from './types'

export interface ManagerPeriodState {
  key: ManagerPeriodKey
}

export function useManagerPeriod() {
  const [state, setState] = useState<ManagerPeriodState>({ key: 'week' })
  const setKey = (key: ManagerPeriodKey) => setState({ key })
  return { state, setKey }
}

async function fetchManagerDashboard(p: ManagerPeriodState): Promise<ManagerDashboardDto> {
  const res = await apiClient.get<{ success: true; data: ManagerDashboardDto }>(
    '/dashboard/manager',
    { params: { period: p.key } },
  )
  return res.data.data
}

export function useManagerDashboard(period: ManagerPeriodState) {
  return useQuery({
    queryKey: ['dashboard', 'manager', period.key],
    queryFn: () => fetchManagerDashboard(period),
    staleTime: 15_000,
    refetchInterval: 60_000,
  })
}
